import { useEffect, useRef } from "react";
import { useReactFlow } from "@xyflow/react";

export default function usePanToSelection(selection, nodes, edges) {
  const { setCenter, getZoom } = useReactFlow();
  const prevSelectionRef = useRef(null);

  useEffect(() => {
    if (!selection) {
      prevSelectionRef.current = null;
      return;
    }

    const selectionKey = `${selection.type}-${selection.id}`;
    if (selectionKey === prevSelectionRef.current) return;
    prevSelectionRef.current = selectionKey;

    let targetX = null;
    let targetY = null;

    if (selection.type === "device" || selection.type === "boundary" || selection.type === "canvasLabel") {
      const node = nodes.find((n) => n.id === selection.id);
      if (!node) return;

      const width = node.measured?.width ?? 200;
      const height = node.measured?.height ?? 100;
      targetX = node.position.x + width / 2;
      targetY = node.position.y + height / 2;
    } else if (selection.type === "edge") {
      const edge = edges.find((e) => e.id === selection.id);
      if (!edge) return;

      const sourceNode = nodes.find((n) => n.id === edge.source);
      const targetNode = nodes.find((n) => n.id === edge.target);
      if (!sourceNode || !targetNode) return;

      const sw = sourceNode.measured?.width ?? 200;
      const sh = sourceNode.measured?.height ?? 100;
      const tw = targetNode.measured?.width ?? 200;
      const th = targetNode.measured?.height ?? 100;

      targetX = (sourceNode.position.x + sw / 2 + targetNode.position.x + tw / 2) / 2;
      targetY = (sourceNode.position.y + sh / 2 + targetNode.position.y + th / 2) / 2;
    }

    if (targetX !== null && targetY !== null) {
      setCenter(targetX, targetY, { duration: 800, zoom: getZoom() });
    }
  }, [selection, nodes, edges, setCenter, getZoom]);
}
